<script lang="ts">
    import { slide }    from 'svelte/transition';
    
	import InputJson    from "./ToolFormInputPresetsInputJson.svelte";
	import InputImages  from "./ToolFormInputPresetsInputImages.svelte";
    import RequreImages from './ToolFormInputPresetsRequreImages.svelte';

    export let base_json   : string;
    export let add_json    : string;
    export let base_images : {name: string; data: string}[];
    export let add_images  : {name: string; data: string}[];

    let require_base_images : {[key: string]: boolean} = {};
    let require_add_images  : {[key: string]: boolean} = {};

    // 使用しているテクスチャ画像がすべて選択されているかの判定
    $: is_selected_base_images = Object.keys(require_base_images).length === Object.values(require_base_images).filter(x=>x).length
    $: is_selected_add_images  = Object.keys(require_add_images).length  === Object.values(require_add_images).filter(x=>x).length
</script>

<div>
    <div transition:slide>
        <h3>STEP 2. ベースになる髪型を選択</h3>
        <InputJson bind:json={base_json} bind:require_images={require_base_images} />
    </div>
    {#if base_json != ''}
        {#if !is_selected_base_images}
            <div transition:slide>
                <InputImages bind:images_list={base_images} bind:require_images={require_base_images} />
                <RequreImages bind:require_images={require_base_images} />
            </div>
        {:else}
            <div transition:slide>
                <p>OK!</p>
            </div>
        {/if}
    {/if}
    {#if base_images.length > 0 && is_selected_base_images}
        <div transition:slide>
            <h3>STEP 3. 追加する髪形を選択</h3>
            <InputJson bind:json={add_json} bind:require_images={require_add_images} />
        </div>
    {/if}
    {#if add_json != ''}
        {#if !is_selected_add_images}
            <div transition:slide>
                <InputImages bind:images_list={add_images} bind:require_images={require_add_images} />
                <RequreImages bind:require_images={require_add_images} />
            </div>
        {:else}
            <div transition:slide>
                <p>OK!</p>
            </div>
        {/if}
    {/if}
</div>
